import replaceCartContent from './replaceCartContent';
import { checkIfAllInstancesOfVariantAddedToCart } from './updateATCButton';

const cartElement = document.getElementById('cart');
const cartDrawerElement = document.getElementById('cart-drawer');
if (!cartElement && !cartDrawerElement) return;

function onCartUpdate() {
  const cartTriggers = document.querySelectorAll('.update-cart');
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;
  const loadingEl = cartDrawer.querySelector('.loading');

  cartTriggers.forEach(async (trigger) => {
    const lineItemId = trigger.dataset.lineItemId;
    const quantity = trigger.dataset.quantity;
    const dependent = trigger.dataset.dependentProduct;
    const mainProductKey = trigger.dataset.mainProductKey;
    trigger.addEventListener('click', async (event) => {
      event.preventDefault();
      if (loadingEl) loadingEl.setAttribute('loading', '');
      const updateCartPromises = [await Shopify.functions.updateCart(lineItemId, quantity)];

      // If not dependent but has mainProductKey it has it's own dependent that should be removed
      if (!dependent && mainProductKey) {
        const dependentCartProduct = trigger?.closest('form')?.querySelector('[data-dependent-product]');
        const dependentlineItemId = dependentCartProduct?.dataset?.lineItemId;
        if (dependentlineItemId) updateCartPromises.push(await Shopify.functions.updateCart(dependentlineItemId, quantity))
      }

      Promise.all(updateCartPromises);
      await replaceCartContent();
      if (loadingEl) loadingEl.removeAttribute('loading');
    });
  });

  checkIfAllInstancesOfVariantAddedToCart();

  const updatedCartEvent = new CustomEvent('cart:updated');
  document.dispatchEvent(updatedCartEvent);
}

onCartUpdate();

export default onCartUpdate;
